import {Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
@Directive({selector: '[StyleCell]'})
export class StyleCellDirective implements OnInit {
  @Input() StyleCell: string;
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}
  ngOnInit() {
    if (this.StyleCell == 'N' || this.StyleCell == 'I') {
      this.renderer.setStyle(this.el.nativeElement, 'text-align', 'right');
    }
  }
}
